var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { "font-weight": "bold", color: "black" } },
    [
      _vm.dataList.length > 0
        ? _c("p", [_vm._v("该预算产品下面包含以下关联产品")])
        : _vm._e(),
      _vm._l(_vm.dataList, function (item, index) {
        return _c(
          "div",
          { key: index, staticStyle: { "margin-top": "10px" } },
          [
            _c("el-checkbox", {
              model: {
                value: item.isCheck,
                callback: function ($$v) {
                  _vm.$set(item, "isCheck", $$v)
                },
                expression: "item.isCheck",
              },
            }),
            _vm._v("   "),
            _c("span", [
              _vm._v(
                _vm._s(item.nameCn) +
                  "/" +
                  _vm._s(item.price) +
                  _vm._s(item.currency)
              ),
            ]),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }